// 统一的接口 base URL
// 本地开发：http://127.0.0.1:8082
// 线上部署：https://sunoapi.leeshisi.cn
export const BASE_URL = 'https://sunoapi.leeshisi.cn';
// export const BASE_URL = 'http://127.0.0.1:8082';
